import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconText2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconText2"><Path d="M3.5 3.5H11.75H20" stroke="currentColor" strokeLinecap="square"/><Path d="M11.75 20V3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconText2;
